/**
 * Shared static style objects for ChatWidget sub-components.
 * Defined outside components so they are not re-created on every render.
 */

export const getChatPanelStyle = (
  x: number,
  y: number,
  sidebarOpened: boolean,
  isMobile: boolean,
) => {
  if (isMobile) {
    return {
      position: 'fixed' as const,
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column' as const,
      zIndex: 1000,
      borderRadius: 0,
      overflow: 'hidden',
    };
  }

  const panelWidth = 800;
  const panelHeight = 600;

  let left = x - panelWidth + 50;
  const minLeft = sidebarOpened ? 210 + 20 : 20;
  if (left < minLeft) {
    left = Math.min(x, window.innerWidth - panelWidth - 20);
    if (left < minLeft) left = minLeft;
  }

  let top = y - panelHeight - 20;
  if (top < 20) {
    top = Math.min(y + 70, window.innerHeight - panelHeight - 20);
    if (top < 20) top = 20;
  }

  return {
    position: 'fixed' as const,
    top,
    left,
    width: panelWidth,
    height: panelHeight,
    display: 'flex',
    flexDirection: 'row' as const,
    zIndex: 1000,
    borderRadius: '16px',
    overflow: 'hidden',
  };
};

export const fabShadow = { boxShadow: '0 4px 12px rgba(0,0,0,0.15)' };

export const clickablePaperSx = {
  cursor: 'pointer',
  '&:hover': { backgroundColor: '#f8f9fa' },
};

export const messageContainerSx = (isMe: boolean) => ({
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: isMe ? ('flex-end' as const) : ('flex-start' as const),
  width: '100%',
});

export const messageBubbleSx = (isMe: boolean) => (t: any) => ({
  backgroundColor: isMe ? t.colors.ltpBlue[0] : t.colors.gray[2],
  color: t.black,
  padding: '8px 12px',
  borderRadius: '12px',
  maxWidth: '80%',
  width: 'fit-content',
  border: isMe ? `1px solid ${t.colors.ltpBlue[1]}` : 'none',
});
